module.exports = __webpack_public_path__ + "static/img/14.f1f01ab.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/10/sp/14.png
// module id = +R7a
// module chunks = 0